if (!customElements.get('product-card--a__checkbox-switch')) {
  customElements.define(
    'product-card--a--checkbox-switch',
    class ProductCardACheckboxSwitch extends HTMLElement {      
      connectedCallback() {
        this.trigger = this.querySelector(".checkbox-switch");
        this.checkbox = this.querySelector(".checkbox-switch input");
        this.target = this.querySelector(".group");
        this.sp_inputs = this.querySelectorAll(".sp_only");
        this.sub_inputs = this.querySelectorAll(".sub_only");
        if (this.trigger && this.target) {
          this.trigger.addEventListener('click', this.onTriggerClick.bind(this));
        } else {
          console.warn('product-card--a__checkbox-switch requires .checkbox-switch and .group elements.');
        }
      }
      
      disconnectedCallback() { this.trigger.removeEventListener('click', this.onTriggerClick); }
      
      onTriggerClick(event) {
        event.preventDefault();
        this.checkbox.checked = !this.checkbox.checked;
        if (this.checkbox.checked) {
          this.target.classList.add("subscribe");
          this.sp_inputs.forEach(element => {
            element.setAttribute("disabled", "disabled")
          })
          this.sub_inputs.forEach(element => {
            element.removeAttribute("disabled");
          })
        } else {
          this.target.classList.remove("subscribe");
          this.sp_inputs.forEach(element => {
            element.removeAttribute("disabled");
          })
          this.sub_inputs.forEach(element => {
            element.setAttribute("disabled", "disabled")
          })
        }
      }
    }
  );
}